import Vue from 'vue';
import Router from 'vue-router';
import main from '../pages/MainPage';

Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:link',
      name: 'home',
      component: main
    },
    {
      path: '/rwanda',
      name: 'rwanda',
      component: main
    },
    // This wild card catches any route that doesn't exist and uses home instead
    {
      path: '*',
      component: main
    }
  ]
});
